namespace Nobox
{
    @Serenity.Decorators.registerEditor()
    export class ProductUnitEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "Bag", text: "Bag" });
            this.addItem({ id: "Botol", text: "Botol" });
            this.addItem({ id: "Box", text: "Box" });
            this.addItem({ id: "Buah", text: "Buah" });
            this.addItem({ id: "Galon", text: "Galon" });
            this.addItem({ id: "Kantong", text: "Kantong" });
            this.addItem({ id: "Kg", text: "Kg" });
            this.addItem({ id: "Kit", text: "Kit" });
            this.addItem({ id: "Lembar", text: "Lembar" });
            this.addItem({ id: "lusin", text: "lusin" });
            this.addItem({ id: "Meter", text: "Meter" });
            this.addItem({ id: "Pack", text: "Pack" });
            this.addItem({ id: "Pasang", text: "Pasang" });
            this.addItem({ id: "Pcs", text: "Pcs" });
            this.addItem({ id: "Roll", text: "Roll" });
            this.addItem({ id: "Sak", text: "Sak" });
            this.addItem({ id: "Set", text: "Set" });
            this.addItem({ id: "Tabung", text: "Tabung" });
            this.addItem({ id: "Tube", text: "Tube" });
            this.addItem({ id: "Unit", text: "Unit" });
        }
    }
}
